/**
 * @generated SignedSource<<bb36e301d493443e22f2f12e9e880e32>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AddExcludeAccountDispatchConditionInput = {
  accountIds: ReadonlyArray<string>;
  clientMutationId?: string | null;
  messageDispatchId: string;
};
export type useDispatchConditions_AddExcludeAccountDispatchConditionMutation$variables = {
  input: AddExcludeAccountDispatchConditionInput;
};
export type useDispatchConditions_AddExcludeAccountDispatchConditionMutation$data = {
  readonly Admin: {
    readonly Message: {
      readonly addExcludeAccountDispatchCondition: {
        readonly clientMutationId: string | null;
      } | null;
    };
  };
};
export type useDispatchConditions_AddExcludeAccountDispatchConditionMutation = {
  response: useDispatchConditions_AddExcludeAccountDispatchConditionMutation$data;
  variables: useDispatchConditions_AddExcludeAccountDispatchConditionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AdminMutationType",
    "kind": "LinkedField",
    "name": "Admin",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MessageAdminMutationSchema",
        "kind": "LinkedField",
        "name": "Message",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
              }
            ],
            "concreteType": "AddExcludeAccountDispatchConditionPayload",
            "kind": "LinkedField",
            "name": "addExcludeAccountDispatchCondition",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "clientMutationId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useDispatchConditions_AddExcludeAccountDispatchConditionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useDispatchConditions_AddExcludeAccountDispatchConditionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8a57e3fb13951f8b58ce2faa4a128119",
    "id": null,
    "metadata": {},
    "name": "useDispatchConditions_AddExcludeAccountDispatchConditionMutation",
    "operationKind": "mutation",
    "text": "mutation useDispatchConditions_AddExcludeAccountDispatchConditionMutation(\n  $input: AddExcludeAccountDispatchConditionInput!\n) {\n  Admin {\n    Message {\n      addExcludeAccountDispatchCondition(input: $input) {\n        clientMutationId\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9d361900c28c65f703e85e9e2af854c7";

export default node;
